export default "__VITE_ASSET__Cj45XaYF__"